import React from 'react';
import '../../App.css';

import HeroSection from '../HeroSection';
import Navbar from '../Navbar';
import Footer from '../footer';



function Home() {
  return (
    <>
      <Navbar />
      <HeroSection />
      <Footer />
     
    </>
  );
}

export default Home;







